RivalIQ.module('graph', function (graph, App, Backbone, Marionette, $, _, d3) {

    'use strict';

    graph.Donut = graph.Block.extend({
        className: 'pie-chart',
        margin: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        },
        remainderSliceLabel: 'Others',
        color: RivalIQ.utils.color.donut,
        donutRatio: 0.4,

        renderData: function (svg, data) {
            const me = this;
            const concept = me.getOption('concept');

            const radius = _.min([me.dimensions.height, me.dimensions.width]) / 2;
            const arc = d3.svg.arc()
                .outerRadius(radius - 10)
                .innerRadius(radius * me.donutRatio);

            const pie = d3.layout.pie()
                .sort(null)
                .value(_.last);

            const chart = svg.select('.grid')
                .attr('transform', `translate(${me.dimensions.width / 2},${me.dimensions.height / 2})`);

            const summarizedData = me.summarizeData(data);

            const slice = chart.selectAll('.slice')
                .data(pie(summarizedData));

            slice
                .enter().append('g')
                .append('path');

            slice
                .attr('fill', getFill)
                .attr('class', getClassName);

            const tooltipContent = _.get(me.options, 'graphOptions.tooltipContent');

            if (tooltipContent) {
                // NOTE popover styling with smooth positioning
                slice
                    .on('mouseover', function (d) {
                        d3.select('#pieChartTooltip').remove();

                        const color = d3.select(this).attr('fill');
                        const tooltip = d3.select('body')
                            .append('div')
                            .attr('id', 'pieChartTooltip')
                            .attr('class', 'popover fade bottom in')
                            .style('display', 'block');
                        const content = tooltip.append('div')
                            .attr('class', 'popover-content');

                        content.html(tooltipContent(d, color));

                        const width = parseInt(tooltip.style('width'));

                        tooltip
                            .style('left', `${d3.event.pageX + 5 - width / 2}px`)
                            .style('top', `${d3.event.pageY + 15}px`);
                    })
                    .on('mousemove', function () {
                        const tooltip = d3.select('#pieChartTooltip');
                        const width = parseInt(tooltip.style('width'));

                        tooltip
                            .style('left', `${d3.event.pageX + 5 - width / 2}px`)
                            .style('top', `${d3.event.pageY + 15}px`);
                    })
                    .on('mouseout', function () {
                        d3.select('#pieChartTooltip').remove();
                    });
            }

            function getFill(d, i) {
                const colorFun = me.getOption('colorFun');
                if (colorFun) {
                    return colorFun(d.data, i);
                }

                return me.color()(d, i);
            }

            function getClassName(d, i) {
                let className = 'slice ';
                if (_.isArray(concept)) {
                    className += concept[i].getClassName();
                } else if (concept) {
                    className += concept.getClassName(summarizedData[i]);
                }

                return className;
            }

            slice.select('path')
                .attr('d', arc);

            slice.exit().remove();
        },

        summarizeData: function (data) {
            const me = this;
            const limit = me.getOption('limit');
            let pieData;
            if (limit) {
                pieData = data.slice(0, limit);

                if (me.getOption('shouldAddRemainder')) {
                    // sum those left behind...
                    const sum = _.sumBy(data.slice(limit), function (datum) {
                        return datum[1];
                    });

                    // only add the remaining slice if there is one
                    if (sum > 0) {
                        pieData.push([
                            me.remainderSliceLabel,
                            sum
                        ]);
                    }
                }
            } else {
                pieData = data;
            }

            return pieData;
        }
    });

    graph.Donut.reloadable = true;
}, window.d3);
